/**
 * Format for standart date
 */
function dateToStandart(sourceDate: string, timeDate:boolean = true): string {
    if(sourceDate) {
        const dateTime = sourceDate.split('+')[0];
        const date = dateTime.split('T')[0];
        const time = dateTime.split('T')[1];
        if(timeDate){
            return time ? `${date} | ${time}` : sourceDate;
        } else {
            return date;
        }
    } else {
        return '–';
    }
}

export default dateToStandart;
